import React, {Fragment, useState} from 'react';
import {NoWrap, Activities, Duration} from 'components';
import {map, useMutationObserver} from 'helpers';
import css from './subtasks-checklist.module.scss';

export function SubRoutinesChecklist({ editable, contextDate, subroutines, detailed }) {
  const [ completed, setCompleted ] = useState(0);
  const hasCheckbox = editable && contextDate;

  const ref = useMutationObserver(() => {
    const completed = ref.current.querySelectorAll('[aria-checked="true"]');
    setCompleted(completed.length);
  });

  return (
    <Fragment>
      <ul className={hasCheckbox ? css.checkList : css.bulletList} ref={ref}>
        { map(subroutines, subroutine =>
          <li key={subroutine.id}>
            { hasCheckbox &&
              <Activities.Checkbox id={subroutine.id} activity={subroutine} className={css.checkbox} />
            }
            <span className={'pull-left '.concat(detailed ? '' : 'one-liner')}>{ subroutine.name }</span>
            { detailed && Boolean(subroutine.duration) &&
              <NoWrap className={css.duration}>
                ( <Duration value={subroutine.duration*60} hideSeconds /> )
              </NoWrap>
            }
            { detailed && Boolean(subroutine.time) &&
              <NoWrap className={css.time}>{ subroutine.time }</NoWrap>
            }
          </li>
        ) }
      </ul>
      { detailed && hasCheckbox && subroutines.length > 1 &&
        <p className={css.progress}>
          { completed }/{ subroutines.length } subroutines
        </p>
      }
    </Fragment>
  );
}
